import React from 'react';
import isNumber from 'lodash/isNumber';

import { useTemplateEditor } from '../components/TemplateEditorProvider';

const useGetTemplateTopic = () => {
    const { templateId } = useTemplateEditor();
    return React.useMemo(() => (templateId && isNumber(templateId) ? `template/${templateId}` : ''), [templateId]);
};

export default useGetTemplateTopic;
